export default __webpack_public_path__ + "static/media/press_room_thumb13.2c8a9f82.png";